export enum TableColumnSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}
